import { isDevLikeEnv } from "@crystal/config";
import { useContext } from "react";
import { createTranslateFunction } from "../lib/index.js";
import { translationsContext } from "./context.js";
function useTranslations() {
  const contextData = useContext(translationsContext);
  if (!contextData) {
    throw `Please use '<TranslationsProvider />' before using 'useTranslations()' hook.`;
  }
  const { context, translations } = contextData;
  return createTranslateFunction(translations, isDevLikeEnv(context.env));
}
export {
  useTranslations
};
//# sourceMappingURL=hooks.js.map
